import EncryptedStorage from 'react-native-encrypted-storage';
import { Platform } from 'react-native';

/**
 * Какие записи «Подсказок и новостей» человек уже открывал.
 *
 * <p>Хранится <b>на устройстве</b>, а не на сервере, и это осознанно: прочитанность подсказки —
 * не часть учётной записи, ради неё не стоит ни таблицы, ни маршрута, ни синхронизации. Плата
 * известна: на новом телефоне лампочка мигнёт ещё раз. Для «прочитал справку» это приемлемо, а
 * для непрочитанных сообщений было бы нет — потому те и живут на сервере.
 *
 * <p>Тем же способом, что и прочие настройки экрана (`savedSectionPrefsStorage`): на вебе
 * `localStorage`, на телефоне защищённое хранилище. Ошибки чтения и записи глотаются — из-за
 * подсказок нельзя уронить список чатов.
 */
const KEY = 'vr_help_seen_v1';

function isWeb(): boolean {
  return Platform.OS === 'web';
}

function normalize(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  const out: string[] = [];
  for (const v of raw) {
    if (typeof v === 'string' && v.length > 0 && !out.includes(v)) out.push(v);
  }
  return out;
}

/**
 * Прочитанные записи; `null` — на этом устройстве ящик ещё ни разу не открывали и ничего не
 * записано (свежая установка). Отличать это от пустого списка нужно `useHelpCenter`: новичку
 * старые новости показываются прочитанными, и лампочка мигает только ради «С чего начать».
 */
export async function readSeenHelpIds(): Promise<string[] | null> {
  try {
    const raw = isWeb()
      ? globalThis.localStorage?.getItem(KEY) ?? null
      : await EncryptedStorage.getItem(KEY);
    if (!raw) return null;
    return normalize(JSON.parse(raw));
  } catch {
    return [];
  }
}

export async function writeSeenHelpIds(ids: readonly string[]): Promise<void> {
  const payload = JSON.stringify(normalize(ids));
  try {
    if (isWeb()) {
      globalThis.localStorage?.setItem(KEY, payload);
      return;
    }
    await EncryptedStorage.setItem(KEY, payload);
  } catch {
    /* ignore storage write errors */
  }
}
